/* GYMGAUR welcome sign-up.
   1. Mobile number fields (snippets/gg-welcome-mobile.liquid): country picker and reading the number, shared by the
      welcome sheet and the signed-in Add your mobile card (gg-herd-mobile). Exposed as window.ggMobile.
   2. The welcome sheet (snippets/gg-welcome-sheet.liquid): opening rules, sending the sign-up in the background,
      and switching from step 1 (join) to step 2 (code, and a second chance to add a mobile).
   3. The signed-in Add your mobile card and the Herd updates thank-you (gg-herd-mobile, gg-herd-subscribe). */
(function () {
  /* ---------- Country picker ---------- */
  var COUNTRIES = [
    ['GB', 'United Kingdom', '44'], ['IE', 'Ireland', '353'], ['US', 'United States', '1'], ['CA', 'Canada', '1'],
    ['AU', 'Australia', '61'], ['NZ', 'New Zealand', '64'], ['FR', 'France', '33'], ['DE', 'Germany', '49'],
    ['ES', 'Spain', '34'], ['IT', 'Italy', '39'], ['PT', 'Portugal', '351'], ['NL', 'Netherlands', '31'],
    ['BE', 'Belgium', '32'], ['LU', 'Luxembourg', '352'], ['CH', 'Switzerland', '41'], ['AT', 'Austria', '43'],
    ['DK', 'Denmark', '45'], ['SE', 'Sweden', '46'], ['NO', 'Norway', '47'], ['FI', 'Finland', '358'],
    ['IS', 'Iceland', '354'], ['PL', 'Poland', '48'], ['CZ', 'Czechia', '420'], ['SK', 'Slovakia', '421'],
    ['HU', 'Hungary', '36'], ['RO', 'Romania', '40'], ['BG', 'Bulgaria', '359'], ['GR', 'Greece', '30'],
    ['CY', 'Cyprus', '357'], ['MT', 'Malta', '356'], ['HR', 'Croatia', '385'], ['SI', 'Slovenia', '386'],
    ['EE', 'Estonia', '372'], ['LV', 'Latvia', '371'], ['LT', 'Lithuania', '370'], ['JE', 'Jersey', '44'],
    ['GG', 'Guernsey', '44'], ['IM', 'Isle of Man', '44'], ['GI', 'Gibraltar', '350'], ['AE', 'United Arab Emirates', '971'],
    ['SA', 'Saudi Arabia', '966'], ['QA', 'Qatar', '974'], ['KW', 'Kuwait', '965'], ['TR', 'Türkiye', '90'],
    ['IL', 'Israel', '972'], ['IN', 'India', '91'], ['PK', 'Pakistan', '92'], ['NG', 'Nigeria', '234'],
    ['GH', 'Ghana', '233'], ['KE', 'Kenya', '254'], ['ZA', 'South Africa', '27'], ['SG', 'Singapore', '65'],
    ['HK', 'Hong Kong', '852'], ['MY', 'Malaysia', '60'], ['TH', 'Thailand', '66'], ['PH', 'Philippines', '63'],
    ['JP', 'Japan', '81'], ['KR', 'South Korea', '82'], ['BR', 'Brazil', '55'], ['MX', 'Mexico', '52']
  ];
  function flag(iso) { return iso.replace(/./g, function (c) { return String.fromCodePoint(127397 + c.charCodeAt(0)); }); }
  var sorted = COUNTRIES.slice(1).sort(function (a, b) { return a[1].localeCompare(b[1]); });
  sorted.unshift(COUNTRIES[0]);

  function initBox(box) {
    if (box.dataset.ggReady) return;
    box.dataset.ggReady = '1';
    var here = (box.getAttribute('data-country') || 'GB').toUpperCase();
    if (!COUNTRIES.some(function (c) { return c[0] === here; })) here = 'GB';
    var select = box.querySelector('[data-gg-cc]');
    var label = box.querySelector('[data-gg-cc-label]');
    var phone = box.querySelector('[data-gg-phone]');
    var sms = box.querySelector('[data-gg-sms]');
    sorted.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c[0];
      o.textContent = flag(c[0]) + '  ' + c[1] + ' (+' + c[2] + ')';
      if (c[0] === here) o.selected = true;
      select.appendChild(o);
    });
    function show() {
      var c = COUNTRIES.filter(function (x) { return x[0] === select.value; })[0] || COUNTRIES[0];
      label.textContent = flag(c[0]) + ' +' + c[2];
      phone.placeholder = c[0] === 'GB' ? '07700 900123' : 'Mobile number';
    }
    select.addEventListener('change', function () { show(); phone.focus(); });
    phone.addEventListener('input', function () { if (phone.value.trim() && !sms.checked) sms.checked = true; });
    show();
  }
  document.querySelectorAll('[data-gg-wmobile]').forEach(initBox);

  // The full number as digits with the country code (447700900123), or an error message
  function readMobile(box) {
    var select = box.querySelector('[data-gg-cc]');
    var raw = (box.querySelector('[data-gg-phone]').value || '').trim();
    if (!raw) return { empty: true };
    var c = COUNTRIES.filter(function (x) { return x[0] === select.value; })[0] || COUNTRIES[0];
    var full;
    var plus = raw.replace(/[\s().-]/g, '');
    if (/^(\+|00)/.test(plus)) {
      full = plus.replace(/^(\+|00)/, '').replace(/\D/g, '');
    } else {
      var national = raw.replace(/\D/g, '');
      if (c[2] !== '39') national = national.replace(/^0/, '');
      full = c[2] + national;
    }
    if (full.indexOf('44') === 0 && !/^447\d{9}$/.test(full)) return { error: 'Enter a UK mobile number, like 07700 900123.' };
    if (!/^\d{8,15}$/.test(full)) return { error: 'Check your mobile number and country code.' };
    if (!box.querySelector('[data-gg-sms]').checked) return { error: 'Tick the box to get texts, so we can add your £5 credit.' };
    return { number: full };
  }
  window.ggMobile = { read: readMobile, init: initBox };
})();

(function () {
  var sheet = document.querySelector('[data-gg-welcome-sheet]');
  if (!sheet) return;
  // Sit directly in the page body so the sheet always covers the window
  document.body.appendChild(sheet);

  var KEY = 'gg-welcome-dismissed', JOINED = 'gg-welcome-joined';
  var form = sheet.querySelector('form');
  var scroller = sheet.querySelector('[data-gg-wscroll]');
  var tagsInput = sheet.querySelector('[data-gg-welcome-tags]');
  var emailInput = sheet.querySelector('[data-gg-welcome-email]');
  var join = sheet.querySelector('[data-gg-wstep="join"]');
  var done = sheet.querySelector('[data-gg-wstep="done"]');
  var BASE_TAGS = 'newsletter,herd-subscribed,welcome-signup';

  function store(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  var readMobile = window.ggMobile.read;

  function say(el, text) { if (!el) return; el.textContent = text || ''; el.hidden = !text; }

  /* ---------- Sending ----------
     Shopify protects customer forms with an invisible spam check (hCaptcha). Its script listens for the form's
     submit event, gets a token, adds it to the form and then calls form.submit(). So the sheet never sends the
     form itself with a button handler: it always goes through a real submit event, and form.submit() is replaced
     on this form so the final send (with the token) happens in the background. If the background send does not
     come back as a success, the form is sent the normal way, again through the spam check. */
  var mode = 'join', normal = false, pendingMobile = null;
  function send() {
    var fd = new FormData(form);
    return fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (/[?&]customer_posted=true/.test(res.url)) return true;
        throw new Error('fallback');
      });
  }
  function sendNormally() {
    store('gg-welcome-y', String(window.scrollY || 0));
    normal = true;
    if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form);
  }
  if (form) {
    form.submit = function () {
      if (normal) return HTMLFormElement.prototype.submit.call(form);
      sendInBackground();
    };
  }
  function busy(btn, on, text) {
    if (!btn) return;
    btn.disabled = on;
    btn.classList.toggle('is-busy', on);
    if (text) btn.textContent = text;
  }

  /* ---------- Step 2 ---------- */
  function markDevice(name, key) {
    try { localStorage.setItem(key, '1'); } catch (e) {}
    document.documentElement.setAttribute(name, '');
  }
  function setDone(withMobile, animate) {
    markDevice('data-gg-joined', JOINED);
    if (withMobile) markDevice('data-gg-joined-sms', 'gg-welcome-sms-added');
    var who = done.querySelector('[data-gg-wwho]');
    if (who) who.textContent = read('gg-welcome-email') || 'the email you joined with';
    var more = done.querySelector('[data-gg-wmore]');
    more.hidden = withMobile;
    done.querySelectorAll('[data-gg-wsms]').forEach(function (el) { el.hidden = !withMobile; });
    var fill = done.querySelector('.gg-ladder__fill');
    var next = done.querySelector('.gg-ladder__next');
    if (fill) {
      if (animate) { fill.style.width = withMobile ? '50%' : '25%'; requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = withMobile ? '75%' : '50%'; }); }); }
      else fill.style.width = withMobile ? '75%' : '50%';
    }
    if (next) { next.style.left = '50%'; next.style.width = '25%'; next.hidden = withMobile; }
  }
  function showStep(step) {
    var from = step === 'done' ? join : done, to = step === 'done' ? done : join;
    from.hidden = true;
    to.hidden = false;
    to.classList.remove('is-entering');
    void to.offsetWidth;
    to.classList.add('is-entering');
    if (scroller) scroller.scrollTop = 0;
  }

  function sendInBackground() {
    send().then(function () {
      if (mode === 'join') {
        setDone(read('gg-welcome-sms') === '1', true);
        showStep('done');
      } else {
        var more = done.querySelector('[data-gg-wmore]');
        more.classList.add('is-leaving');
        setTimeout(function () { more.classList.remove('is-leaving'); setDone(true, true); }, 200);
      }
    }).catch(function () { sendNormally(); });
  }

  if (form) {
    // Runs before Shopify's spam check: check the fields and fill in the email and tags, or stop the send
    window.addEventListener('submit', function (e) {
      if (e.target !== form || normal) return;
      if (mode === 'mobile') return;
      var msg = join.querySelector('[data-gg-wmsg]');
      var email = (emailInput.value || '').trim();
      say(msg, '');
      var m = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? readMobile(join.querySelector('[data-gg-wmobile]')) : { error: 'Enter your email address.' };
      if (m.error) {
        e.preventDefault();
        e.stopImmediatePropagation();
        say(msg, m.error);
        if (!email) emailInput.focus();
        return;
      }
      tagsInput.value = BASE_TAGS + (m.number ? ',sms-' + m.number : '');
      store('gg-welcome-email', email);
      store('gg-welcome-sms', m.number ? '1' : '0');
      try { localStorage.setItem(JOINED, '1'); } catch (err) {}
      busy(join.querySelector('[data-gg-wjoin]'), true, 'Joining');
    }, true);
    // Runs after it: if the spam check took over it will call form.submit() with its token; if not, send now
    window.addEventListener('submit', function (e) {
      if (e.target !== form || normal) return;
      if (e.defaultPrevented) return;
      e.preventDefault();
      sendInBackground();
    });

    done.querySelector('[data-gg-wadd]').addEventListener('click', function () {
      var box = done.querySelector('[data-gg-wmobile]');
      var msg = done.querySelector('[data-gg-wmsg2]');
      say(msg, '');
      var m = readMobile(box);
      if (m.empty) { say(msg, 'Enter your mobile number.'); box.querySelector('[data-gg-phone]').focus(); return; }
      if (m.error) { say(msg, m.error); return; }
      var email = read('gg-welcome-email');
      if (!email) { say(msg, 'Something went wrong. Close this and sign up again with your mobile.'); return; }
      mode = 'mobile';
      emailInput.value = email;
      tagsInput.value = 'sms-' + m.number;
      store('gg-welcome-sms', '1');
      busy(this, true, 'Adding');
      if (form.requestSubmit) form.requestSubmit(); else sendInBackground();
    });
  }

  sheet.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gg-welcome-copy]');
    if (!b) return;
    var code = b.getAttribute('data-gg-welcome-copy');
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(function () { b.textContent = 'Copied'; }, function () {});
  });

  /* ---------- Opening ---------- */
  function whenReady(fn) { if (window.ggSheet) fn(); else setTimeout(function () { whenReady(fn); }, 50); }
  var posted = /[?&]customer_posted=true/.test(location.search);
  var justPosted = posted && (location.hash === '#GgWelcome-sheet' || read('gg-welcome-y') !== null);
  if (!justPosted && !done.hidden) { done.hidden = true; join.hidden = false; } // another sign-up form on the page was sent
  if (justPosted) {
    try { sessionStorage.removeItem('gg-welcome-y'); } catch (e) {}
    // Back from a normal send: stay where they were, drop the #anchor jump, and open on step 2
    var y = parseInt(read('gg-welcome-y') || '0', 10);
    try { var u = new URL(location.href); u.searchParams.delete('customer_posted'); u.hash = ''; history.replaceState(null, '', u.toString()); } catch (e) {}
    window.scrollTo(0, y);
    setDone(read('gg-welcome-sms') === '1', false);
    whenReady(function () { window.ggSheet.open('gg-welcome-sheet'); });
    return;
  }
  if (!document.documentElement.hasAttribute('data-gg-welcome')) return;
  if (/\/pages\/herd|\/cart|\/checkout|\/account/.test(location.pathname)) return;
  var force = read('gg_welcome') === '1';
  try {
    if (!force && localStorage.getItem(JOINED) === '1') return;
    var at = parseInt(localStorage.getItem(KEY) || '0', 10);
    if (!force && at && Date.now() - at < 14 * 24 * 60 * 60 * 1000) return;
  } catch (e) {}
  var opened = false;
  function open() {
    if (opened || !window.ggSheet) return;
    if (document.documentElement.classList.contains('gg-sheet-open')) return;
    opened = true;
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    window.ggSheet.open('gg-welcome-sheet');
  }
  setTimeout(open, 8000);
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0 && window.innerWidth > 989) open();
  });
})();

/* Signed-in members: the Herd updates thank-you (+25 XP) and the Add your mobile card (gg-herd-subscribe, gg-herd-mobile) */
(function () {
  function say(el, text) { if (!el) return; el.textContent = text || ''; el.hidden = !text; }

  /* Thank-you: back from the Herd updates form, the address ends with that form's id */
  if (/[?&]customer_posted=true/.test(location.search) && location.hash) {
    var id = location.hash.slice(1);
    var thanks = document.querySelector('[data-gg-herd-thanks="' + id.replace(/"/g, '') + '"]');
    if (thanks) {
      thanks.hidden = false;
      var plain = thanks.parentNode.querySelector('[data-gg-herd-subscribed]');
      if (plain) plain.hidden = true;
      var sheet = thanks.closest('.gg-herd-sheet');
      if (sheet) sheet.classList.add('is-thanks');
      requestAnimationFrame(function () { requestAnimationFrame(function () { thanks.classList.add('is-in'); }); });
    }
  }

  /* Add your mobile: the same background send as the welcome sheet, through Shopify's spam check (see there) */
  document.querySelectorAll('[data-gg-herd-mobile] form').forEach(function (form) {
    var card = form.closest('[data-gg-herd-mobile]');
    var box = card.querySelector('[data-gg-wmobile]');
    var msg = card.querySelector('[data-gg-herd-mobile-msg]');
    var btn = card.querySelector('[data-gg-herd-mobile-btn]');
    var tags = card.querySelector('[data-gg-herd-mobile-tags]');
    var KEY = 'gg-herd-mobile-sent';
    var normal = false;
    if (window.ggMobile) window.ggMobile.init(box);

    function showDone() {
      card.querySelector('[data-gg-herd-mobile-ask]').hidden = true;
      var d = card.querySelector('[data-gg-herd-mobile-done]');
      d.hidden = false;
      d.classList.add('is-in');
      // The Herd page's level and credit panels say it's on its way too (after a reload, Liquid shows the same lines)
      function note(after, cls, text) {
        if (!after || document.querySelector('.' + cls)) return;
        var p = document.createElement('p');
        p.className = cls;
        p.textContent = text;
        after.insertAdjacentElement('afterend', p);
      }
      note(document.querySelector('.gg-herd-status__main .gg-herd-bar'), 'gg-herd-status__pending', '+25 XP and £5 Herd credit on the way for adding your mobile. They land within about 20 minutes.');
      note(document.querySelector('.gg-herd-credit__amount'), 'gg-herd-credit__pending', '+£5 on the way for adding your mobile. It shows here within about 20 minutes.');
    }
    function send() {
      fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (res) { if (!/[?&]customer_posted=true/.test(res.url)) throw new Error('fallback'); showDone(); })
        .catch(function () {
          try { sessionStorage.setItem(KEY, form.id); } catch (e) {}
          normal = true;
          if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form);
        });
    }
    form.submit = function () { if (normal) return HTMLFormElement.prototype.submit.call(form); send(); };

    // Before Shopify's spam check: check the number and fill in the tag, or stop the send
    window.addEventListener('submit', function (e) {
      if (e.target !== form || normal) return;
      say(msg, '');
      var m = window.ggMobile ? window.ggMobile.read(box) : { error: 'Please try again.' };
      if (m.empty) m = { error: 'Enter your mobile number.' };
      if (m.error) { e.preventDefault(); e.stopImmediatePropagation(); say(msg, m.error); return; }
      tags.value = 'sms-' + m.number;
      btn.disabled = true;
      btn.classList.add('is-busy');
      btn.textContent = 'Adding';
    }, true);
    // After it: if the check took over it calls form.submit() with its token; if not, send now
    window.addEventListener('submit', function (e) {
      if (e.target !== form || normal || e.defaultPrevented) return;
      e.preventDefault();
      send();
    });

    // Back from a normal send
    var sent = null;
    try { sent = sessionStorage.getItem(KEY); } catch (e) {}
    if (sent === form.id && /[?&]customer_posted=true/.test(location.search)) {
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      showDone();
    }
  });
})();
